<template>
  <div class="hero is-small">
    <!-- Hero image -->
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="columns is-vcentered">
          <div class="column is-6 is-offset-3 mb-90">
            <!-- Login form -->
            <div class="animated preFadeInLeft fadeInLeft pb-90" id="printMe">
              <router-link to="/" class="logo">
                <img class src="~/../assets/images/logos/brand-logo.png" alt />
              </router-link>
              <hr />
              <h4 class="title is-4">حجز موعد سحب نقدي</h4>

              <hr />
              <a class="button button-cta primary-btn is-bold is-large mt-20">
                <b>يوم {{ customerdate }}</b>
              </a>
              <br />

              <a class="button button-cta primary-btn is-bold is-large mt-20">
                <b>بتوقيت {{ customertime }}</b>
              </a>
              <br />
              <a class="button button-cta primary-btn is-bold is-large mt-20">
                <b>رقم الحجز {{ id }}</b>
              </a>
              <hr />

           
              <!-- <h4 class="title is-4">رجاء الالتزام بالحضور <span v-if="confirmation_messages"> و احضار معاكم التالي</span></h4> -->

              <hr />

              <div v-if="confirmation_messages" class="mt-5 mb-10">
                <ul>
                  <li
                    v-for="message in confirmation_messages"
                    :key="message"
                    class="title is-4"
                  >
                    {{ message }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="mt-20">
           
              <a
                class="
                  button
                  is-info
                  btn-align
                  modal-dismiss
                  is-bold is-medium
                  ml-20
                "
                @click="print"
              >
                <b>طباعة</b>
              </a>

              <router-link to="/">
                <a
                  class="
                    button
                    is-dark   mx-20
                    btn-align
                    modal-dismiss
                    is-bold is-medium
                  "
                >
                  <b>عودة للرئيسية</b>
                </a>
              </router-link>
            </div>

            <div class="hero-foot has-text-centered mt-20"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";

const today = new Date();
const min = new Date();
min.setHours(9);
min.setMinutes(0);
const max = new Date();
max.setHours(18);
max.setMinutes(0);
export default {
  name: "withdrawalbooking",
  props: [
    "customerdate",
    "customertime",
    "customer_id",
    "id",
    "confirmation_messages",
  ],

  data() {
    return {
      customerdate: null,
      customertime: null,
      customer_id: null,
      id: null,
    };
  },
  created() {
    if (this.customerdate == null || this.customertime == null) {
      this.$router.push("/");
    }
  },
  methods: {
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe");
    },
  },
  mounted() {
    // this.confirmation_messages = [ 'test1' , 'test2']
  },
};
</script>
